import { AutoSuggestOptionProps } from './types';

// eslint-disable-next-line
function AutoSuggestOption<T>(props: AutoSuggestOptionProps<T>) {
    const {
        id,
        value,
        displayText,
        selected = undefined, // default props
        onClick,
        ariaLabel,
    } = props;

    return (
        <li
            role='option'
            id={id}
            aria-selected={id === selected}
            aria-label={ariaLabel}
            className={id === selected
                ? 'suggestion-option auto-suggestions highlighted'
                : 'suggestion-option auto-suggestions'}
            onClick={() => onClick({ displayText, id, value })}
            onKeyDown={() => {}}
        >
            <span aria-hidden='true'>{displayText}</span>
        </li>
    );
}

// AutoSuggestOption.defaultProps = {
//     selected: undefined,
// };

export default AutoSuggestOption;
